<app-modal-header title="Not only hearts break, this function too..." (onClose)="dialogRef.close()"></app-modal-header>

<mat-dialog-content>
  <div class="text-gray-400 text-sm">
    <p class="mb-3">
      <i class="fas fa-heart-broken fa-4x text-gray-600"></i>
    </p>
    <p class="mb-3">
      Something went wrong.
    </p>

    <div [ngSwitch]="data.modal">
      <p *ngSwitchCase="'could-not-get-valid-access-token'" class="mb-3">
        We could not get a valid authorization for your integration. Please try again or re-authenticate this integration.
      </p>

      <p class="mb-3" *ngSwitchDefault>
        You can try to refresh the page and try again, or let us know if you have any additional detail.
      </p>

    </div>
    <p class="mb-3">
      Sorry for the inconveniences.
    </p>
  </div>

</mat-dialog-content>

